import { captureRemixErrorBoundaryError } from "@sentry/remix";
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useLoaderData,
  useRouteError,
} from "@remix-run/react";
import "./tailwind.css";
import "./fonts.css";
import { LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import { themeSessionResolver } from "~/theme.server";
import {
  PreventFlashOnWrongTheme,
  ThemeProvider,
  useTheme,
} from "remix-themes";
import { cn } from "~/lib/utils";

export const meta: MetaFunction = () => {
  return [{ title: "Linkt" }];
};

export async function loader({ request }: LoaderFunctionArgs) {
  const { getTheme } = await themeSessionResolver(request);
  return {
    ssrTheme: getTheme(),
    ENV: {
      TURNSTILE_SITE_KEY: process.env.TURNSTILE_SITE_KEY,
      DISABLE_TURNSTILE: process.env.DISABLE_TURNSTILE,
    },
  };
}

export const ErrorBoundary = () => {
  const error = useRouteError();
  captureRemixErrorBoundaryError(error);
  return <div>Something went wrong</div>;
};

export default function AppWithProviders() {
  const { ssrTheme } = useLoaderData<typeof loader>();
  return (
    <ThemeProvider specifiedTheme={ssrTheme} themeAction="/action/set-theme">
      <App />
    </ThemeProvider>
  );
}

export function App() {
  const { ssrTheme } = useLoaderData<typeof loader>();
  const [theme] = useTheme();
  return (
    <html lang="en" className={cn(theme)}>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <PreventFlashOnWrongTheme ssrTheme={Boolean(ssrTheme)} />
        <Links />
      </head>
      <body>
        <Outlet />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}
